import Header from "@/layouts/Header";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import { Drawer } from "antd";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, Outlet } from "react-router-dom";
import { loadPermissionById } from "../redux/rtk/features/auth/authSlice";
import { cn } from "../utils/functions";
import Footer from "./Footer";
import SideNav from "./SideNav/SideNav";
const roleId = localStorage.getItem("roleId");
const mode = import.meta.env.VITE_APP_VERSION;

function AdminLayout() {
  const dispatch = useDispatch();
  const [collapsed, setCollapsed] = useState(false);
  const [visible, setVisible] = useState(false);
  const [imageError, setImageError] = useState();
  const { data, loading } = useSelector((state) => state?.setting) || {};
  const {
    list: permissions,
    loading: permissionLoad,
    error,
  } = useSelector((state) => state.auth) || {};

  const handleCollapsed = (val) => {
    setCollapsed(val);
  };

  const openDrawer = () => setVisible(!visible);

  useEffect(() => {
    if (!permissions && !permissionLoad && !error) {
      dispatch(loadPermissionById(roleId));
    }
  }, [dispatch, error, permissionLoad, permissions]);

  return (
    <main
      className={cn("relative  w-full h-screen overflow-hidden flex flex-row", {
        "h-[calc(100vh-32px)] mt-8": mode === "demo",
      })}>
      <div
        className={`hidden md:flex dark:bg-transparent bg-white dark:border-gray-50 border-gray hover:bg-transparent  border-2 text-gray-500 absolute top-[10px] left-[225px] w-[30px] h-[30px] leading-[30px] rounded-full justify-center items-center z-30 duration-300  ${!collapsed
          ? "top-[10px] md:left-[185px] 2xl:left-[225px]"
          : "top-[10px] left-[70px]"
          }`}>
        {collapsed ? (
          <RightOutlined
            onClick={() => handleCollapsed(!collapsed)}
            className="text-[16px] cursor-pointer"
          />
        ) : (
          <LeftOutlined
            onClick={() => handleCollapsed(!collapsed)}
            className="text-[16px] cursor-pointer"
          />
        )}
      </div>
      {/* for small device */}
      <Drawer
        title={false}
        closable={false}
        onClose={() => setVisible(false)}
        open={visible}
        placement="left"
        width={240}>
        <div className="min-h-screen overflow-auto no-scrollbar w-[240px] bg-gradient-to-b from-[#13A877] to-[#0B4D3A] text-white select-none">
          {/* Top company header */}
            <Link
            to="/admin"
            className="sticky top-0 z-10 flex items-center gap-2 h-[56px] px-3 border-b bg-transparent"
          >
            <img
              src="/images/HRMSmart-New-logo-v2.png"
              alt="logo"
              className="h-20 w-auto object-contain"
            />
          </Link>

          {/* SideNav contents */}
          <div className="pt-0">
            <SideNav />
          </div>
        </div>
      </Drawer>

      {/* // for large device */}
      <div
        className={cn(
          " hidden shadow-md border-r md:block left-0 top-0 z-10  duration-300 h-screen  w-[200px] 2xl:w-[240px] bg-gradient-to-b from-[#13A877] to-[#0B4D3A]  text-white select-none",
          { "w-[86px] 2xl:w-[86px]": collapsed }
        )}>
        <Link
          to={"/admin"}
          className="w-full h-[80px] flex items-center justify-center mt-2 mb-2 cursor-pointer px-2">
          {!collapsed ? (
            <img
              alt="logo"
              src="/images/HRMSmart-New-logo-v2.png"
              style={{ width: "195px", height: "68px", objectFit: "contain" }}
            />
          ) : (
            <img
              alt="icon"
              src="/images/HRMSmart-New-icon-v2.png"
              style={{ width: "40px", height: "40px", objectFit: "contain" }}
            />
          )}
        </Link>

        <SideNav collapsed={collapsed} setCollapsed={setCollapsed} />
      </div>
      <div
        className={cn(
          `flex flex-col w-full 2xl:w-[calc(100vw-240px)] md:w-[calc(100vw-200px)] duration-300`,
          {
            "md:w-[calc(100vw-86px)] 2xl:w-[calc(100vw-86px)]": collapsed,
          }
        )}>
        <Header onPress={openDrawer} data={data} loading={loading} />
        <div className="flex-1 p-4 min-h-0 overflow-auto">
          <Outlet />
        </div>
        <Footer />
      </div>
    </main>
  );
}

export default AdminLayout;
